import { useEffect, useState } from "react";

const useMousePosition = () => {
  const [position, setPosition] = useState({
    clientXDot: 0,
    clientYDot: 0,
  });

  const updatePosition = (event) => {
    const { clientX, clientY } = event;
    setPosition({
      clientXDot: clientX,
      clientYDot: clientY,
    });
  };

  useEffect(() => {
    document.addEventListener("mousemove", updatePosition, false);
    document.addEventListener("mouseenter", updatePosition, false);

    return () => {
      document.removeEventListener("mousemove", updatePosition);
      document.removeEventListener("mouseenter", updatePosition);
    };
  }, []);

  return position;
};

const useMousePositionDelay = () => {
  const [position, setPosition] = useState({
    clientXCircle: 0,
    clientYCircle: 0,
  });

  const updatePosition = (event) => {
    const { clientX, clientY } = event;
    setTimeout(() => {
      setPosition({
        clientXCircle: clientX,
        clientYCircle: clientY,
      });
    }, 100);
  };

  useEffect(() => {
    document.addEventListener("mousemove", updatePosition, false);
    document.addEventListener("mouseenter", updatePosition, false);

    return () => {
      document.removeEventListener("mousemove", updatePosition);
      document.removeEventListener("mouseenter", updatePosition);
    };
  }, []);

  return position;
};

export default function Cursor() {
  const { clientXDot, clientYDot } = useMousePosition();
  const { clientXCircle, clientYCircle } = useMousePositionDelay();
  return (
    <div className="custom-cursor">
      <div className="dot-cursor">
        <svg
          width={30}
          height={30}
          viewBox="0 0 50 50"
          style={{
            position: "absolute",
            left: clientXDot,
            top: clientYDot,
            transform: "translate(-50%, -50%)",
          }}
        >
          <circle cx="25" cy="25" r="8" />
        </svg>
      </div>
      <div className="circle">
        <svg
          width={60}
          height={60}
          viewBox="0 0 100 100"
          style={{
            position: "absolute",
            left: clientXCircle,
            top: clientYCircle,
            transform: "translate(-50%, -50%)",
          }}
        >
          <circle
            className="progress-ring__circle"
            r="40"
            cx="50"
            cy="50"
            fill="transparent"
          />
        </svg>
      </div>
    </div>
  );
}
